export function getYoutubeThumbnail(id: string): string {
  return `https://img.youtube.com/vi/${encodeURI(id)}/hqdefault.jpg`;
}
